// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"690a48f3","823":"1da657d7"}[chunkId] + ".chunk.js";
};